
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



function MakeAppoinment() {


      const [formData, setFormData] = useState({
    form_name: "",
    form_phnnumber: "",
    form_email: "",
    service: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };


    const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch("https://mystra.in/apiMail/indus-contact.php", {
      method: "POST",
      headers: {
         "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams(formData)
    });

    const result = await response.json();

    if (result.status === "success") {
      toast.success("Form submitted successfully!");
      setFormData({
        form_name: "",
        form_phnnumber: "",
        form_email: "",
        service: ""
      });
    } else {
      toast.error(result.message);
    }

  } catch (error) {
    toast.error("Something went wrong!");
  }
};

    return (
      <>
        {/* <!--Start Consultation form--> */}
                                    <div className="appoinment-form">
                                        <section className="appoinment-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-5 col-sm-12 col-xs-12">
                                    <div className="img-holder">
                                        <img src="assets/images/ContactUs.png" alt="Awesome Image"/>
                                    </div>    
                                </div>
                                <div className="col-md-6 col-sm-12 col-xs-12">
                                    <div className="appoinment">
                                        <div className="sec-title">
                                            <h1><span>Book a free online consultation</span></h1>
                                            <p>Just fill out the following form, our expert team will contact and make sure you get the highest level of help.</p>
                                        </div>
                                  <form className="appoinment-form" onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6 field-input">
          <input
            type="text"
            name="form_name"
            placeholder="Name"
            value={formData.form_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-6 field-input">
          <input
            type="text"
            name="form_phnnumber"
            placeholder="Mobile Number"
            value={formData.form_phnnumber}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 field-input">
          <input
            type="email"
            name="form_email"
            placeholder="Email"
            value={formData.form_email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-6 field-input">
          <select
           className="selectmenu"
            name="service"
            value={formData.service}
            onChange={handleChange}
            required
          >
            <option value="">Select Service</option>
            <option>Skid Mounted Refpacks</option>
            <option>Process Chillers and Coolers</option>
            <option>Heat Pumps</option>
            <option>ICE Production systems</option>
            <option>Ammonia Recirculator Package</option>
            <option>Cooling Condenser</option>
            <option>Freezers</option>
            <option>Pressure Vessels</option>
            <option>Control Systems</option>
            <option>Support Services</option>
          </select>
        </div>
      </div>
  <div className="row">
                                                <div className="col-md-12">
                                                       <button type="submit">Submit Now</button>
                                                </div>
                                            </div>
   
    </form>
                                        <ToastContainer
    position="bottom-right"
    autoClose={3000}
    hideProgressBar={false}
    closeOnClick
    pauseOnHover
    draggable
    theme="colored"
  />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                                    </div>
                                    {/* <!--End Consultation form--> */}
      </>
    )
      
}

export default MakeAppoinment;